<content>
  <form [formGroup]="changePasswordForm" [ngClass]="{'show-error': showError}">
    <div class="infoPassword">{{'session.passwordRequirements' | translate}}</div>
    <div class="entry" *ngIf="!recovery">
      <label>{{'session.currentPassword' | translate}} *</label>
      <input [type]="showOPassword ? 'text' : 'password'" formControlName="oldPassword">
      <span>
        <i [ngClass]="showOPassword ? 'fa fa-eye-slash': 'fa fa-eye'" (click)="showOPassword = !showOPassword"
            title="{{ showOPassword ? ('session.hidePassword' | translate) : ('session.showPassword' | translate)}}"></i>
      </span>
    </div>
    <div class="entry">
      <label>{{'session.newPassword' | translate}} *</label>
      <input [type]="showNPassword ? 'text' : 'password'" formControlName="newPassword">
      <span>
        <i [ngClass]="showNPassword ? 'fa fa-eye-slash': 'fa fa-eye'" (click)="showNPassword = !showNPassword"
            title="{{ showNPassword ? ('session.hidePassword' | translate) : ('session.showPassword' | translate)}}"></i>
      </span>
    </div>
    <div class="entry">
      <label>{{'session.repeatNewPassword' | translate}} *</label>
      <input [type]="showRNPassword ? 'text' : 'password'" formControlName="repeatNewPassword">
      <span>
        <i [ngClass]="showRNPassword ? 'fa fa-eye-slash': 'fa fa-eye'" (click)="showRNPassword = !showRNPassword"
            title="{{ showRNPassword ? ('session.hidePassword' | translate) : ('session.showPassword' | translate)}}"></i>
      </span>
    </div>
  </form>
</content>
<footer>
  <button (click)="changePassword();">{{ 'global.confirmar' | translate}}</button>
</footer>
<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
